var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPendingToUploadInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.26562 13C6.6108 13 6.89062 12.7202 6.89062 12.375C6.89062 12.0298 6.6108 11.75 6.26562 11.75C5.92045 11.75 5.64062 12.0298 5.64062 12.375C5.64062 12.7202 5.92045 13 6.26562 13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0156 8C15.3608 8 15.6406 7.72018 15.6406 7.375C15.6406 7.02982 15.3608 6.75 15.0156 6.75C14.6704 6.75 14.3906 7.02982 14.3906 7.375C14.3906 7.72018 14.6704 8 15.0156 8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26562 3.625C6.6108 3.625 6.89062 3.34518 6.89062 3C6.89062 2.65482 6.6108 2.375 6.26562 2.375C5.92045 2.375 5.64062 2.65482 5.64062 3C5.64062 3.34518 5.92045 3.625 6.26562 3.625Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26562 9.875C6.26562 7.46667 8.23229 5.5 10.6406 5.5C11.7073 5.5 12.6823 5.88333 13.4406 6.51667L14.2406 5.55833C13.2656 4.74167 12.0073 4.25 10.6406 4.25C7.53229 4.25 5.01562 6.76667 5.01562 9.875C5.01562 10.2 5.04896 10.5167 5.09896 10.8333L6.33229 10.6167C6.29062 10.375 6.26562 10.125 6.26562 9.875Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.14062 9.875C3.14062 7.80833 3.98229 5.93333 5.34063 4.575L4.45729 3.69167C2.87396 5.275 1.89062 7.46667 1.89062 9.875C1.89062 14.7083 5.80729 18.625 10.6406 18.625V17.375C6.50729 17.375 3.14062 14.0083 3.14062 9.875Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6406 2.375C14.774 2.375 18.1406 5.74167 18.1406 9.875H19.3906C19.3906 5.04167 15.474 1.125 10.6406 1.125C9.59062 1.125 8.59062 1.31667 7.65729 1.65833L8.08229 2.83333C8.88229 2.54167 9.74062 2.375 10.6406 2.375Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6406 14.3583L16.1156 9.875L11.599 14.3583L12.4823 15.2417L15.4906 12.2583V19.875H16.7406V12.2583L19.7573 15.2417L20.6406 14.3583Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPendingToUploadInformation);
export default __webpack_public_path__ + "static/media/ic-pending-to-upload-information.1a561758e7453f3712b65b4a7499d639.svg";
export { ForwardRef as ReactComponent };